import { List, Tooltip } from 'antd';
import React from 'react';
import classnames from 'classnames';
import { splitSearchHit } from '@web-contact/util';
import styles from './index.module.scss';
import Checkbox from '../Checkbox';
import { isOrg } from '@web-common/components/util/contact';
import { ContactOrgAvatar } from '@web-common/components/UI/Avatar/contactOrgAvatar';
import { contactApi } from '@web-common/utils/contact_util';
import { Space } from 'antd';
import { transTreeName } from '../tree/data';
import EyeOutlined from '@ant-design/icons/EyeOutlined';
import { getIn18Text } from 'api';
import { CustomerLabelByRole } from '@web-mail/components/ReadMail/component/CustomerLabel';
const ListItem = props => {
    const { testId, isLeaf = true, showPosition, showAvatar, item, onSelect, onDelete, searchText, checked, disableCheck, selected, showCheckbox, showDelete, showMailListIcon, onSelectMailListIcon, className, style, type, } = props;
    const renderHighLight = (text) => {
        if (!searchText) {
            return text;
        }
        const result = splitSearchHit(searchText, text);
        if (!result) {
            return text;
        }
        return (React.createElement(React.Fragment, null,
            result.head,
            React.createElement("b", { className: styles.hitText }, result.target),
            result.tail));
    };
    const renderDepartment = (position) => {
        if (position === undefined) {
            return '';
        }
        return position.map(de => de.join('/')).join('-');
    };
    const renderDelete = () => {
        return (React.createElement("div", { className: `dark-invert ${styles.itemDelete}`, onClick: () => {
                onDelete && onDelete(item);
            } }));
    };
    let subtitle;
    let title;
    let titleTip;
    let department = React.createElement(React.Fragment, null);
    let titleLabelRole;
    let isContact;
    let isMailList = false;
    const _isOrg = !isLeaf || isOrg(item);
    if (_isOrg) {
        const org = item;
        const isTeam = org.type === 2000;
        if (item.type === 2002 || item.type === 2003) {
            titleLabelRole = org.customerRole;
        }
        title = renderHighLight(org.orgName);
        titleTip = org.orgName;
        title = (React.createElement(React.Fragment, null,
            title,
            isTeam && org.memberNum !== undefined ? `（${org.memberNum}${getIn18Text('REN')}）` : ''));
    }
    else {
        const contact = item;
        title = renderHighLight(contact.name || contact.email);
        titleTip = contact.name || contact.email;
        titleLabelRole = contact.customerRole;
        isContact = true;
        subtitle = renderHighLight(contact.email);
        if (showPosition && contact.position) {
            department = React.createElement("p", { className: styles.subtitle }, renderDepartment(contact.position));
        }
        isMailList = Boolean(contact.accountType !== undefined && contactApi.isMailListByAccountType(contact.accountType));
    }
    return (React.createElement(List.Item, { "data-test-id": testId, style: style, onClick: () => {
            onSelect && onSelect();
        }, className: classnames(styles.item, styles[type], className, {
            [styles.itemSelect]: selected,
            [styles.itemSelectDisable]: disableCheck,
        }) },
        React.createElement("div", { className: classnames(styles.itemWrap, {
                [styles.itemWrapPaddingRight]: showDelete && type === 'normal',
            }) },
            React.createElement("div", { className: styles.itemAvatar },
                React.createElement("div", { className: styles.itemAvatarContainer },
                    showCheckbox ? (React.createElement("div", { className: styles.itemAvatarCheckbox },
                        React.createElement(Checkbox, { checked: checked, disabled: disableCheck }))) : null,
                    showAvatar ? (React.createElement("div", { className: styles.itemAvatarWrap },
                        React.createElement(ContactOrgAvatar, { item: item }))) : null)),
            React.createElement("div", { className: styles.itemContent },
                React.createElement("div", { className: styles.titleWrap },
                    React.createElement(Tooltip, { title: titleTip, mouseEnterDelay: 1 },
                        React.createElement("i", { className: classnames(styles.titleName, disableCheck && styles.disableName) }, title)),
                    titleLabelRole && React.createElement(CustomerLabelByRole, { role: titleLabelRole, isContact: isContact, style: { marginLeft: 8 } }),
                    showMailListIcon && isMailList && (React.createElement("b", { className: styles.mailListIcon, onClick: e => {
                            e.stopPropagation();
                            if (item) {
                                onSelectMailListIcon && onSelectMailListIcon(item);
                            }
                        } },
                        React.createElement(Tooltip, { title: transTreeName('memberList') },
                            React.createElement(Space, null,
                                React.createElement(EyeOutlined, null)))))),
                subtitle && (React.createElement("div", { className: styles.descWrap },
                    React.createElement(Tooltip, { title: isLeaf ? subtitle : '', mouseEnterDelay: 1 },
                        React.createElement("p", { className: styles.subtitle }, subtitle)),
                    department))),
            showDelete && type === 'normal' ? renderDelete() : null)));
};
export default ListItem;
